<div class="custom-form">
	<fieldset *ngIf="fromLoginContext | async as context">
		<legend>{{ fromAppName ? fromAppName : "From"}} login</legend>
		<div class="login-row">
			<dx-lookup id="fromAppLookupComponent" #fromAppLookup [items]="context.fromApplicationLogins"
				displayExpr="name" [value]="context.data" (onValueChanged)="valueChanged($event, 'from')"
				itemTemplate="listItem" noDataText="There are no existing logins" fieldTemplate="field"
				class="login-lookup">
				<div *dxTemplate="let item of 'field'">
					<div *ngIf="item">
						<div style="float:left">
							<ng-container *ngIf="context.data === item">
								<i class="far fa-check">&nbsp;</i>
							</ng-container>
							<ng-container *ngIf="context.data != item">
								<i class="far fa-minus">&nbsp;</i>
							</ng-container>
						</div>
						{{item.name}}
					</div>
				</div>

				<div *dxTemplate="let item of 'listItem'">
					<div style="float:left">
						<ng-container *ngIf="context.data === item">
							<i class="far fa-check">&nbsp;</i>
						</ng-container>
						<ng-container *ngIf="context.data != item">
							<i class="far fa-minus">&nbsp;</i>
						</ng-container>
					</div>
					{{item.name}}
				</div>
			</dx-lookup>
		</div>
		<div class="buttons-row" *ngIf="{disabled: fromButtonsDisabled$ | async} as buttonsContext">
			<button (click)="editApplicationLoginBtn(formGroup.get('from'), 1, linkInfo.fromApplicationId, context.data, 'from', context.fromApplicationLoginParams)" class="btn btn-sm add-login-button btn-primary"
			[disabled]="buttonsContext.disabled || !context.data?.id">
				<i class="far fa-pencil"></i>Edit</button>
			<button (click)="editApplicationLoginBtn(formGroup.get('from'), 1, linkInfo.fromApplicationId, null, 'from', context.fromApplicationLoginParams)" class="btn btn-sm add-login-button btn-primary"
			[disabled]="buttonsContext.disabled">
				<i class="far fa-plus"></i>Create</button>
			<button (click)="deleteApplicationLoginBtn($event, context.data, 'from')" class="btn btn-sm add-login-button btn-primary"
			[disabled]="buttonsContext.disabled || !context.data?.id"><i class="far fa-trash"></i>Delete</button>
			<al-link-edit-application-login-auth [disabled]="buttonsContext.disabled || !context.data?.id" [formGroup]="formGroup.get('from')" [linkId]="link.id" [appSide]="'from'" [fromLinkType]="linkInfo.type" [applicationId]="linkInfo.fromApplicationId" [applicationName]="fromAppName" [appParams]="context.fromApplicationLoginParams"></al-link-edit-application-login-auth>
			<button *ngIf="isAdmin" (click)="openApplicationLoginArticleAdmin(context.data, 'from')" class="btn btn-sm add-login-button btn-primary admin-articles-button"
			[disabled]="buttonsContext.disabled || !context.data?.id">
				<i class="far fa-book"></i>[Admin] Articles</button>
		</div>
	</fieldset>
	<fieldset *ngIf="toLoginContext | async as context">
		<legend>{{ toAppName ? toAppName: "To" }} login</legend>
		<div class="login-row">
			<dx-lookup #toAppLookup [items]="context.toApplicationLogins" displayExpr="name"
				(onValueChanged)="valueChanged($event, 'to')" [value]="context.data"
				noDataText="There are no existing logins" itemTemplate="listItem" class="login-lookup"
				fieldTemplate="field">
				<div *dxTemplate="let item of 'field'">
					<div *ngIf="item">
						<div style="float:left">
							<ng-container *ngIf="context.data === item">
								<i class="far fa-check">&nbsp;</i>
							</ng-container>
							<ng-container *ngIf="context.data != item">
								<i class="far fa-minus">&nbsp;</i>
							</ng-container>
						</div>
						{{item.name}}
					</div>
				</div>
				<div *dxTemplate="let item of 'listItem'">
					<div style="float:left">
						<ng-container *ngIf="context.data === item">
							<i class="far fa-check">&nbsp;</i>
						</ng-container>
						<ng-container *ngIf="context.data != item">
							<i class="far fa-minus">&nbsp;</i>
						</ng-container>
					</div>
					{{item.name}}
				</div>
			</dx-lookup>
		</div>
		<div class="buttons-row" *ngIf="{disabled: toButtonsDisabled$ | async} as buttonsContext">
			<button (click)="editApplicationLoginBtn(formGroup.get('to'), 2, linkInfo.toApplicationId, context.data, 'to', context.toApplicationLoginParams)" class="btn btn-sm add-login-button btn-primary"
			[disabled]="buttonsContext.disabled || !context.data?.id">
				<i class="far fa-pencil"></i>Edit</button>
			<button (click)="editApplicationLoginBtn(formGroup.get('to'), 2, linkInfo.toApplicationId, null, 'to', context.toApplicationLoginParams)" class="btn btn-sm add-login-button btn-primary"
			[disabled]="buttonsContext.disabled">
				<i class="far fa-plus"></i>Create</button>
			<button (click)="deleteApplicationLoginBtn($event, context.data, 'to')" class="btn btn-sm add-login-button btn-primary"
			[disabled]="buttonsContext.disabled || !context.data?.id">
				<i class="far fa-trash"></i>Delete</button>
			<al-link-edit-application-login-auth [disabled]="buttonsContext.disabled || !context.data?.id" [formGroup]="formGroup.get('to')" [linkId]="link.id" [appSide]="'to'" [fromLinkType]="linkInfo.type" [applicationId]="linkInfo.fromApplicationId" [applicationName]="toAppName" [appParams]="context.toApplicationLoginParams"></al-link-edit-application-login-auth>
			<button *ngIf="isAdmin" (click)="openApplicationLoginArticleAdmin(context.data, 'to')" class="btn btn-sm add-login-button btn-primary admin-articles-button"
			[disabled]="buttonsContext.disabled || !context.data?.id">
				<i class="far fa-book"></i>[Admin] Articles</button>
		</div>
	</fieldset>
</div>
<button *ngIf="isAdmin" (click)="openAppLoginManagementModal()" class="btn btn-primary btn-sm">[Admin] Manage app login
	fields</button>
<al-link-edit-auth-generic-modal #editAppFieldModal></al-link-edit-auth-generic-modal>

<al-link-edit-application-login-modal (loginSaved)="onLoginSaved($event)"></al-link-edit-application-login-modal>
<al-link-edit-application-login-article-admin (articlesSaved)="onLoginArticlesSaved($event)"></al-link-edit-application-login-article-admin>
